import React, { PropsWithChildren } from "react";
import { ColorType, TouchableBox } from "arkh";
import { ActivityIndicator, StyleProp, ViewStyle } from "react-native";

export function CircleButton(
  props: PropsWithChildren<{
    onPress: () => void;
    loading?: boolean;
    style: StyleProp<ViewStyle>;
    color?: ColorType;
  }>
) {
  return (
    <TouchableBox
      style={[
        {
          position: "absolute",
          height: 50,
          width: 50,
          borderRadius: 25,
          alignItems: "center",
          opacity: props.loading ? 0.5 : 1,
          justifyContent: "center",
        },
        props.style,
      ]}
      color={props.color ?? "surface-backgroundControl"}
      onPress={props.onPress}
      disabled={props.loading === true}
    >
      {props.loading ? (
        <>
          <ActivityIndicator />
        </>
      ) : (
        props.children
      )}
    </TouchableBox>
  );
}
